import { render } from "./ViewsCatalog.vue?vue&type=template&id=4a8d2e7e"
import script from "./ViewsCatalog.vue?vue&type=script&lang=js"
export * from "./ViewsCatalog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__